// src/components/Header/hooks/useHeaderNavigation.js
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setDialogId, setMessages } from '../components/ChatApp/chatSlice';
import { selectUserId } from '../components/Login/loginSlice';

export const useHeaderNavigation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = useSelector(selectUserId);

  const navigateToProfile = () => {
    // setMenuOpen(false);
    navigate('/profile');
  };

  const navigateToChat = () => {
    // setMenuOpen(false);
    navigate('/chat');
  };

  const navigateToStorage = () => {
    // setMenuOpen(false);
    navigate('/storage');
  };

  const navigateToLogin = () => {
    // setMenuOpen(false);
    localStorage.removeItem('authData');
    localStorage.removeItem(`lastDialogId_${userId}`);
    dispatch(setDialogId(null));
    dispatch(setMessages([]));
    navigate('/login');
  };

  const navigateToMain = () => {
    window.location.href = 'https://bottax.tech';
  };

  return {
    navigateToProfile,
    navigateToChat,
    navigateToStorage,
    navigateToLogin,
    navigateToMain,
  };
};
